import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function Watermark() {
  const { user } = useAuth();
  const [, tick] = useState(0);

  // Refresh the stamped time each minute so a screenshot shows a near-current clock.
  useEffect(() => {
    const id = setInterval(() => tick(t => t + 1), 60000);
    return () => clearInterval(id);
  }, []);

  if (!user) return null;
  if (user.role === 'admin') return null;

  const stamp = new Date().toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' });
  const text = `${user.name || user.email} · ${user.email} · ${stamp}`;
  return (
    <div
      aria-hidden
      data-testid="watermark-overlay"
      style={{
        position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 9999,
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute', top: '-50%', left: '-50%', width: '200%', height: '200%',
          transform: 'rotate(-30deg)',
        }}
      >
        {Array.from({ length: 60 }).map((_, i) => (
          <div
            key={i}
            style={{
              position: 'absolute',
              top: `${i * 80}px`,
              left: 0,
              width: '100%',
              fontSize: '12px',
              color: 'rgba(0,0,0,0.08)',
              fontFamily: 'monospace',
              whiteSpace: 'nowrap',
              userSelect: 'none',
            }}
          >
            {Array.from({ length: 12 }).map((__, j) => (
              <span key={j} style={{ marginRight: '120px' }}>{text}</span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
